module.exports = __webpack_public_path__ + "f40f693acac4ddbc4e4d62c845798ca7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image6.png
 ** module id = 284
 ** module chunks = 0
 **/